import { render, staticRenderFns } from "./donation.vue?vue&type=template&id=7b28a0a8&scoped=true"
import script from "./donation.vue?vue&type=script&lang=js"
export * from "./donation.vue?vue&type=script&lang=js"
import style0 from "./donation.vue?vue&type=style&index=0&id=7b28a0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b28a0a8",
  null
  
)

export default component.exports